import C3Chart from './C3Chart';

export default C3Chart;
